





































































import { Component, Prop, Watch } from "vue-property-decorator";

import { mixins } from "vue-class-component";
import LoadingMixin from "@/mixins/LoadingMixin";
import ContentMixin from "@/mixins/ContentMixin";
import { IAnswer, IUSection } from "@/store/types";
import BaseDropdown from "@/components/base/template/vue-argon-design-template/BaseDropdown.vue";
import { Action, Getter } from "vuex-class";
import QuestionBody from "@/components/ccat/QuestionBody.vue";
import QuestionControl from "@/components/ccat/QuestionControl.vue";
import { IPassage, IQuestion } from "@/store/modules/content/types";
import smoothScroll from "@/helpers";
import { IUser } from "@/store/modules/auth/types";

@Component({
  name: "test-take",
  components: {
    QuestionBody,
    QuestionControl,
    BaseDropdown,
  },
})
export default class TestTake extends mixins(LoadingMixin, ContentMixin) {
  @Prop({ default: false, type: Boolean })
  public isPracticeAssessment!: boolean;

  @Prop({ required: true, type: Function })
  public handleSaveAnswer!: (obj: Partial<IAnswer>) => Promise<void>;

  @Prop({ required: true, type: Object })
  public section!: IUSection;

  @Prop({ required: true, type: Array })
  public questions!: IQuestion[] | any;

  @Prop({ required: true, type: Array })
  public passages!: IPassage[] | any;

  @Prop({ default: null })
  public question!: IQuestion;

  @Prop({ default: null })
  public isConnected!: { isConnected: boolean; isSectionStarted: boolean };

  @Getter("isOfflineTest", { namespace: "authModule" })
  public isOffline!: boolean;

  @Getter("isOfflineEntryStudent", { namespace: "authModule" })
  public isOfflineEntryStudent!: boolean;

  @Getter("account", { namespace: "authModule" })
  public account!: IUser;

  @Action("unsetToken", { namespace: "authModule" })
  public unsetToken!: () => Promise<void>;

  private autoAdvance: boolean = true;
  private hasError: boolean = false;
  private passageHeight: number = 0;

  private optionOver = "";
  private answer_obj: any = null;
  private sortingAnswers = false;
  private isProcessingOption = false;

  public get passageBoxHeight() {
    return this.passageHeight;
  }

  get questionsCT() {
    return this.questions ? Object.keys(this.questions).length : 0;
  }

  get answeredCT() {
    return this.questions
      .filter((q: { student_answer: any }) => q.student_answer)
      .reduce((a: number) => a + 1, 0);
  }

  public manageHeight() {
    this.$nextTick(function() {
      const windowHeight = window.innerHeight;

      const minHeight = 55; //percent
      const percentOf = (minHeight / 100) * windowHeight;

      if (this.$refs && this.$refs.examOnlineRightIn) {
        const el = this.$refs.examOnlineRightIn as HTMLElement;
        const rightHeight = el.clientHeight;

        this.passageHeight = rightHeight < percentOf ? percentOf : rightHeight;
      }
    });
  }

  @Watch("isConnected", { immediate: true })
  private onIsConnetedChange(
    value: {
      isConnected: boolean;
      isSectionStarted: boolean;
    },
    old: {
      isConnected: boolean;
      isSectionStarted: boolean;
    }
  ) {
    if (!value.isConnected && value.isSectionStarted) {
      this.unsetToken();
      this.notifyError({});
    } else if (!value.isConnected) {
      throw {
        data: {
          message:
            "An unknown error occurred. Check your internet connection and try again.",
        },
      };
    }
  }

  @Watch("question", { immediate: true })
  private onQuestionChange() {
    if (this.question && this.question.type === "O") {
      if (
        this.question.student_answer === "SKIP" ||
        !this.question.student_answer
      ) {
        if (this.question.student_answer !== "SKIP") {
          this.$set(this.question, "student_answer", null);
        }

        this.answer_obj = Object.keys(this.question.content_da).map(
          (q: any, idx: number) => idx + 1
        );
      } else {
        if (typeof this.question.student_answer === "string") {
          this.$set(this.question, "correct_obj", null);
          this.$set(this.question, "correct", "SKIP");
        } else {
          this.answer_obj = Object.values(this.question.student_answer);
        }
      }
    }

    setTimeout(() => {
      this.manageHeight();
      const el = this.$refs.contentBody as HTMLElement;
      smoothScroll({
        duration: 300,
        element: el,
        to: 0,
      });
    }, 300);
  }

  get passage(): IPassage | {} {
    const ret: any = {};

    if (this.passages) {
      for (const key of Object.keys(this.passages)) {
        const passage = this.passages[key];

        if (
          this.question.num >= passage.start_num &&
          this.question.num <= passage.end_num
        ) {
          if (passage.passage) {
            ret.text = passage.passage;
          }

          const questionAudio: any = this.questions.find(
            (q: { num: any }) => q.num === passage.start_num
          );

          const audio = questionAudio["content_text"][0]["audio"];

          if (audio !== undefined) {
            ret.audio = audio;
          }
        }
      }
    }

    return ret;
  }

  public get isActExam(): boolean {
    return this.section.exam === "act";
  }

  public get isFinished(): boolean {
    return this.answeredCT === this.questionsCT;
  }

  public async onQuestionsNav(num: number) {
    if (this.question && this.question.student_answer) {
      await this.saveAnswer(this.question.student_answer);
    }

    await this.gotoQuestion(num);
  }

  private async gotoQuestion(num: number) {
    if (num <= this.questionsCT) {
      this.isLoading = true;
      await this.$emit("section:nav:question", num);
      this.isLoading = false;
    }
  }

  private sectionFinished(): void {
    this.$emit("section:finished");
  }

  private async saveAnswer(choice: Map<number, number> | string | null) {
    this.$Progress.start();
    if (this.section.is_completed) return;
    if (!this.question) throw new Error("Question is null");

    const answer: any = {
      usection_id: this.section.id,
      question_id: this.question.id,
      question_num: this.question.num,
      time_spent: 0,
      time_remain: 0,
      answer: null,
      answer_obj: null,
    };

    if (typeof choice === "string") {
      answer.answer = choice;
    } else {
      answer.answer_obj = choice;
    }

    try {
      this.isLoading = true;
      await this.handleSaveAnswer(answer);
      await this.handleSectionChoice(choice);
      this.$Progress.finish();
    } catch (e) {
      this.autoAdvance = false;
      this.isLoading = false;
      //this.unsetToken();
      //this.notifyError(e);
      this.$Progress.fail();
      throw e;
    } finally {
      this.isLoading = false;
    }
  }

  public async handleSectionChoice(
    choice: Map<number, number> | string | null
  ) {
    if (this.question) {
      await this.$set(this.question, "student_answer", choice);
      if (typeof choice === "string") {
        await this.$set(this.question, "correct", choice);
        await this.$set(this.question, "correct_obj", null);
      } else {
        await this.$set(this.question, "correct", null);
        await this.$set(this.question, "correct_obj", choice);
      }
    }
  }

  // TODO: Refactory to rise an exception with info about the question
  private notifyError(err: any): void {
    if (err && err.status === 428) {
      throw err;
    }

    err = err || {};
    err.data = err.data || {};
    err.type = "CUSTON_ERROR";
    err.fixed = true;

    err.data.closeButtonLabel = "Close";
    err.data.modalClasses = "modal-lg";
    err.data.message = `
        <div class="row">
          <div class="col-12">
            <div class="row ml-0 mr-0">`;

    this.questions.forEach((question: any) => {
      err.data.message += `
        <div class="card-question col-lg-1 col-sm-4 col-xs-4 col-s-2">
          <div class="card card-sm bg-white mb-3">
            <div class="card-header text-center text-black-50">
              <b>${question.num}</b>
            </div>
            <div class="card-body text-center">
              <h6 class="card-text">
                ${
                  question && question.hasOwnProperty("student_answer")
                    ? question.student_answer
                    : "--"
                }
              </h6>
            </div>
          </div>
        </div>
        `;
    });

    err.data.message += `
          </div>
        </div>
      </div>
      `;

    err.data.message += `
        <div class="row">
          <div class="col">
            <p>A connection error occurred. Please write down your answers beforing trying again.</p>
          </div>
        </div>
      `;

    throw err;
  }

  public onOptionOver(event: string) {
    this.optionOver = event;
  }

  public async onOptionSelected(event: any) {
    if (this.isProcessingOption) {
      return;
    }

    this.isProcessingOption = true;
    await this.$set(this.question, "student_answer", event);
    this.sortingAnswers = false;

    if (typeof event === "string") {
      this.answer_obj = null;
    }

    await this.saveAnswer(event);

    if (this.autoAdvance && this.question.student_answer) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const self = this;

      setTimeout(async function() {
        const next = self.question.num + 1;
        await self.gotoQuestion(next);
      }, 300);
    }
    this.isProcessingOption = false;
  }
}
